// Integração com o Asaas (cobrança) — Administração > Conta & Integrações
// (2026-08-28: migrado da antiga tela solta "Integrações" no menu lateral,
// ver admin.integrations.tsx). Backend próprio (2026-08-27),
// administrador-only (ver requireAdmin em guards/permission.guard.ts no
// backend). Mesmo padrão de gpsdrive-client-profile.service.ts.
import { gpsDriveGet, gpsDrivePost, gpsDrivePut } from "@/lib/api/gpsdrive-client";

export interface AsaasIntegrationStatus {
  enabled: boolean;
  // Nunca a chave em si — o backend nunca devolve a chave de API, só se
  // ela está configurada (pra UI decidir entre campo vazio e placeholder
  // "chave configurada").
  hasApiKey: boolean;
  // Dias até o vencimento de uma cobrança nova (sugestão de padrão).
  dueDays: number;
  // Dias de atraso até suspender a conta do cliente automaticamente —
  // null = suspensão automática desligada. Só a configuração é salva aqui;
  // a rotina que efetivamente suspende ainda não existe no backend.
  suspensionDays: number | null;
}

export interface UpdateAsaasIntegrationInput {
  // Omitido reaproveita a chave já salva no backend (só troca enabled) —
  // usado quando o admin só liga/desliga sem digitar uma chave nova.
  apiKey?: string;
  enabled: boolean;
  dueDays?: number;
  // null explícito desliga a suspensão automática; omitido mantém o valor
  // já salvo.
  suspensionDays?: number | null;
}

export const gpsDriveAsaasIntegrationService = {
  get: () => gpsDriveGet<AsaasIntegrationStatus>("/api/v1/integrations/asaas"),
  update: (input: UpdateAsaasIntegrationInput) =>
    gpsDrivePut<AsaasIntegrationStatus>("/api/v1/integrations/asaas", input),
};

// "Puxar dados do Asaas" (pedido 2026-10-26) — busca na conta Asaas da
// empresa por CPF/CNPJ (completo) ou nome, e vincula o cadastro escolhido
// ao usuário (faturamento). Ver components/asaas-customer-picker.tsx.
export interface AsaasCustomerSearchItem {
  id: string;
  name: string;
  cpfCnpj: string | null;
  email: string | null;
  mobilePhone: string | null;
  phone: string | null;
  postalCode: string | null;
  address: string | null;
  addressNumber: string | null;
  complement: string | null;
  province: string | null;
  cityName: string | null;
  state: string | null;
  dateCreated: string | null;
  paymentsCount: number | null;
  linkedUser: { id: string; name: string } | null;
}

export const gpsDriveAsaasCustomersService = {
  search: (q: string) =>
    gpsDriveGet<AsaasCustomerSearchItem[]>(`/api/v1/users/asaas-customers?q=${encodeURIComponent(q)}`),
  link: (userId: string, asaasCustomerId: string) =>
    gpsDrivePost<{ asaasCustomerId: string }>(`/api/v1/users/${userId}/client-profile/asaas-link`, { asaasCustomerId }),
  missingCpfTraccarIds: () =>
    gpsDriveGet<{ traccarUserIds: number[] }>("/api/v1/users/client-profile/missing-cpf"),
};
